import styled from 'styled-components'

export const StyledInputField = styled.input`
  width: ${props => props.width || '100%'};
  height: ${props => props.height};
  display: block;
  border-radius: 0;
  min-height: 24px;
  padding: 6px 12px;
  text-align: ${props => props.textAlign || 'left'};
  border: 1px solid ${props => props.error && props.value !== ''
    ? 'red'
    : props.theme.colors.pearlGrey};
  &:focus {
    padding: 5px 11px;
    outline: none;
    border: 2px solid ${props => props.theme.colors.lightBlue};
    box-shadow: none;
  }
  &::placeholder {
    color: ${props => props.theme.colors.blueGrey};
  }
  &:disabled {
    color: inherit;
    background-color: inherit;
  }
`

export const PanelContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  
`

export const StyledButton = styled.button`
margin: 16px 0px 0px 0px;
padding: 6px 12px;
border: solid 2px ${props => props.disabled ? props.theme.colors.pearlGrey : props.theme.colors.lightBlue};
color: ${props => props.disabled ? '#fff' : props.theme.colors.lightBlue};
background-color: ${props => props.disabled ? props.theme.colors.pearlGrey : 'transparent'};
border-radius: 0;
min-width: 120px;
white-space: nowrap;
text-transform: uppercase;
font-size: 16px;
font-weight: 400;
&:hover {
  color: #fff;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  background-color: ${props => props.disabled ? props.theme.colors.pearlGrey : props.theme.colors.darkerLtGrey};
  border-color: ${props => props.disabled ? props.theme.colors.pearlGrey : props.theme.colors.darkerLtGrey};
}
`

export const StyledLink = styled.a`
padding: 12px 20px;
border: solid 2px ${props => props.theme.colors.lightBlue};
color: #fff;
background-color: ${props => props.theme.colors.lightBlue};
border-radius: 0;
white-space: nowrap;
cursor: pointer;
text-transform: uppercase;
font-size: 16px;
font-weight: 400;
&:hover {
  text-decoration: none;
  color: #fff;
  cursor: pointer;
}
`

export const Divider = styled.div`
  width: 100%;
  border-bottom: 1px solid ${props => props.theme.colors.pearlGrey};
`

export const FormContainer = styled.div`
 flex: 1 1;
 padding: 0;
 margin: 16px 0px;
`

export const CurrencyIcon = styled.div`
position: absolute;
top: 0;
height: 100%;
display: flex;
align-items: center;
padding-left: 12px;
`

export const InputWithIconContainer = styled.div`
  position: relative;
`

export const LabelContainer = styled.div`
  flex: 1;
`

export const TotalLabel = styled.h3`
  margin-top: 20px;
`

export const ProductListContainer = styled.div`
  margin-bottom: 16px;
`
